import { RenderInfo } from "../../renders/RenderInfo";
import { ILaya } from "../../../ILaya";
import { Texture2D } from "../../resource/Texture2D";
import { TextureFormat } from "../../RenderEngine/RenderEnum/TextureFormat";
import { FilterMode } from "../../RenderEngine/RenderEnum/FilterMode";
import { WrapMode } from "../../RenderEngine/RenderEnum/WrapMode";
import { TextAtlas } from "./TextAtlas";
import { LayaEnv } from "../../../LayaEnv";
import { TextRender } from "./TextRender";
import { LayaGL } from "../../layagl/LayaGL";
export class TextTexture extends Texture2D {
    constructor(textureW = TextRender.atlasWidth, textureH = TextRender.atlasWidth) {
        super(textureW, textureH, TextureFormat.R8G8B8A8, false, false, true, true);
        this._discardTm = 0;
        this.genID = 0;
        this.curUsedCovRate = 0;
        this.curUsedCovRateAtlas = 0;
        this.lastTouchTm = 0;
        this.ri = null;
        this.setPixelsData(null, true, false);
        this.lock = true;
        this.filterMode = FilterMode.Bilinear;
        this.wrapModeU = WrapMode.Clamp;
        this.wrapModeV = WrapMode.Clamp;
        if (TextRender.debugUV) {
            this.fillWhite();
        }
    }
    addChar(data, x, y, uv = null) {
        if (TextRender.isWan1Wan) {
            return this.addCharCanvas(data, x, y, uv);
        }
        var dt = data.data;
        if (data.data instanceof Uint8ClampedArray)
            dt = new Uint8Array(dt.buffer);
        LayaGL.textureContext.setTextureSubPixelsData(this._texture, dt, 0, false, x, y, data.width, data.height, true, false);
        var u0;
        var v0;
        var u1;
        var v1;
        u0 = x / this.width;
        v0 = y / this.height;
        u1 = (x + data.width) / this.width;
        v1 = (y + data.height) / this.height;
        uv = uv || new Array(8);
        uv[0] = u0, uv[1] = v0;
        uv[2] = u1, uv[3] = v0;
        uv[4] = u1, uv[5] = v1;
        uv[6] = u0, uv[7] = v1;
        return uv;
    }
    addCharCanvas(canv, x, y, uv = null) {
        LayaGL.textureContext.setTextureSubImageData(this._texture, canv, x, y, true, false);
        var u0;
        var v0;
        var u1;
        var v1;
        if (LayaEnv.isConch) {
            u0 = x / this.width;
            v0 = y / this.height;
            u1 = (x + canv.width) / this.width;
            v1 = (y + canv.height) / this.height;
        }
        else {
            u0 = (x + 1) / this.width;
            v0 = (y + 1) / this.height;
            u1 = (x + canv.width - 1) / this.width;
            v1 = (y + canv.height - 1) / this.height;
        }
        uv = uv || new Array(8);
        uv[0] = u0, uv[1] = v0;
        uv[2] = u1, uv[3] = v0;
        uv[4] = u1, uv[5] = v1;
        uv[6] = u0, uv[7] = v1;
        return uv;
    }
    fillWhite() {
        var dt = new Uint8Array(this.width * this.height * 4);
        dt.fill(0xff);
        LayaGL.textureContext.setTextureImageData(this._getSource(), dt, true, false);
    }
    discard() {
        ILaya.stage.setGlobalRepaint();
        this.destroy();
        return;
    }
    static getTextTexture(w, h) {
        return new TextTexture(w, h);
    }
    static clean() {
        var curtm = RenderInfo.loopStTm;
        if (TextTexture.cleanTm === 0)
            TextTexture.cleanTm = curtm;
        if (curtm - TextTexture.cleanTm >= TextRender.checkCleanTextureDt) {
            for (let i = 0; i < TextTexture.poolLen; i++) {
                var p = TextTexture.pool[i];
                if (curtm - p._discardTm >= TextRender.destroyUnusedTextureDt) {
                    p.destroy();
                    TextTexture.pool[i] = TextTexture.pool[TextTexture.poolLen - 1];
                    TextTexture.poolLen--;
                    i--;
                }
            }
            TextTexture.cleanTm = curtm;
        }
    }
    touchTexture() {
        let frame = RenderInfo.loopCount;
        if (this.lastTouchTm != frame) {
            this.curUsedCovRate = 0;
            this.curUsedCovRateAtlas = 0;
            this.lastTouchTm = frame;
        }
    }
    touchRect(ri, frame) {
        if (this.lastTouchTm != frame) {
            this.curUsedCovRate = 0;
            this.curUsedCovRateAtlas = 0;
            this.lastTouchTm = frame;
        }
        var texw2 = TextRender.atlasWidth * TextRender.atlasWidth;
        var gridw2 = TextAtlas.atlasGridW * TextAtlas.atlasGridW;
        this.curUsedCovRate += (ri.bmpWidth * ri.bmpHeight) / texw2;
        this.curUsedCovRateAtlas += (Math.ceil(ri.bmpWidth / TextAtlas.atlasGridW) * Math.ceil(ri.bmpHeight / TextAtlas.atlasGridW)) / (texw2 / gridw2);
    }
}
TextTexture.pool = new Array(10);
TextTexture.poolLen = 0;
TextTexture.cleanTm = 0;
TextTexture.EVENT_REUSE = 'texture_recycling';
